<div class="custom-toolbar">
  <div id="before-toolbar" class="custom-toolbar-subdivision">
    <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
    <yo-commande-fournisseur-date-filter
      [selectedDates]="[null, null]"
      (onValueChange)="onDateFilterValueChange($event)"
    >
    </yo-commande-fournisseur-date-filter>

    <dx-text-box
      class="box-size-1"
      placeholder="Filtrer par numéro de commande..."
      (onValueChanged)="onChangeFilterNumCommande($event)"
    >

    </dx-text-box>

    <dx-tag-box
      class="box-size-1"
      [multiline]="false"
      [dataSource]="filterItemsFournisseur"
      placeholder="Filtrer par fournisseur..."
      displayExpr="value"
      valueExpr="id"
      [searchEnabled]="true"
      [showSelectionControls]="true"
      (onValueChanged)="onChangeFilterFournisseurs($event)"
    >
      <div *dxTemplate="let fournisseur of 'item'">
        <div [title]="fournisseur.value">
          {{fournisseur.value}}
        </div>
      </div>
    </dx-tag-box>

    <dx-tag-box
      class="box-size-1"
      [multiline]="false"
      [dataSource]="filterItemsUdp"
      placeholder="Filtrer par unité de production..."
      displayExpr="value"
      valueExpr="id"
      [searchEnabled]="true"
      [showSelectionControls]="true"
      (onValueChanged)="onChangeFilterUdps($event)"
    >
    </dx-tag-box>

    <dx-text-box
      class="box-size-1"
      placeholder="Filtrer par article..."
      (onValueChanged)="onChangeFilterArticles($event)"
    >
    </dx-text-box>

    <dx-tag-box
      class="box-size-2"
      [dataSource]="filterItemsListeBesoin"
      placeholder="Filtrer par liste de besoins..."
      displayExpr="value"
      valueExpr="id"
      [searchEnabled]="true"
      [showSelectionControls]="true"
      [multiline]="false"
      (onValueChanged)="onChangeFilterListesBesoins($event)"
    >
    </dx-tag-box>
  </div>
  <div id="after-toolbar" class="custom-toolbar-subdivision">
    <yo-button iconClass="fas fa-play"
               tooltip="Passer à l'étape suivante"
               [disabled]="isActionDisabled" (onClick)="menu.toggle($event)">
      <p-menu appendTo="body" #menu [popup]="true" [model]="nextSteps"></p-menu>
    </yo-button>
    <yo-button
      iconClass="fa fa-envelope"
      (onClick)="sendMail()"
      [disabled]="isActionDisabled || isSendMailDisabled"
      tooltip="Envoyer par mail les commandes aux fournisseurs sélectionnés">
    </yo-button>
    <yo-button
      iconClass="fas fa-print"
      (onClick)="menuOptionsPrint.toggle($event)"
      [disabled]="isActionDisabled"
      tooltip="Imprimer les commandes sélectionnées au format pdf">
      <p-menu appendTo="body" #menuOptionsPrint [popup]="true" [model]="optionsPrint"></p-menu>
    </yo-button>
    <yo-button
      iconClass="fas fa-code-merge"
      (onClick)="openMergeDialog()"
      [disabled]="isActionDisabled || !isMergeAvailable"
      tooltip="Fusionner les propositions sélectionnées">
    </yo-button>
    <yo-button
      iconClass="fa fa-trash"
      buttonClass="cta-inner-delete"
      (onClick)="menuDeleteOptions.toggle($event)"
      tooltip="Supprimer les commandes sélectionnées">
      <p-menu appendTo="body" #menuDeleteOptions [popup]="true" [model]="deleteOptions"></p-menu>
    </yo-button>
  </div>
</div>

<dx-data-grid
  (onSelectionChanged)="checkDisabledButtons()"
  [dataSource]="dataSource"
  [remoteOperations]="true"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [allowColumnResizing]="true"
  (onCellClick)="cellClick($event)"
  #grid>
  <dxo-selection [deferred]="true" [allowSelectAll]="true" [showCheckBoxesMode]="checkBoxesMode"
                 mode="multiple"></dxo-selection>

  <dxi-column dataField="id" caption="Actions" [width]="100" cellTemplate="templateActions"
              [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="numeroBcf" caption="Bon de commande" cellTemplate="templateBonCf"
              alignement="left"></dxi-column>
  <dxi-column dataField="bonReceptionList" caption="Bon de réception" cellTemplate="templateBonReception"
              alignement="left"></dxi-column>
  <dxi-column dataField="dateCommande" caption="Date commande" cellTemplate="templateDateCommande"
              alignement="left"></dxi-column>
  <dxi-column dataField="dateLivraisonAjustee" alignement="left" caption="Date livraison"
              cellTemplate="templateDateLivraison"></dxi-column>
  <dxi-column dataField="fournisseurLibelle" caption="Fournisseur"></dxi-column>
  <dxi-column dataField="uniteDeProductionLibelle" caption="Unité de production"
              cellTemplate="templateUdp"></dxi-column>
  <dxi-column dataField="montantHT" caption="Montant HT" alignment="left" cellTemplate="templateMontantHT"></dxi-column>
  <dxi-column dataField="commentaire" caption="Remarque(s)" alignment="left"
              cellTemplate="templateRemarques"></dxi-column>
  <dxi-column dataField="listeBesoinLibelle" caption="Liste de besoins" alignment="left"
              cellTemplate="templateLbde"></dxi-column>

  <div *dxTemplate="let cell of 'templateActions'" class="custom-button-container">
    <yo-cell-button (yoNavigation)="openObject(cell.row.data)"
                    [yoTooltipShowDelay]="1500"
                    [yoSmall]="true"
                    yoTextAlign="center"
                    [yoIconClass]="auth2Svc.isSiteLocal(cell.row.data.site.id)? 'fas fa-edit':'fas fa-eye'"
                    [yoTooltip]="auth2Svc.isSiteLocal(cell.row.data.site.id)? 'Modifier la commande':'Voir la commande'"
    ></yo-cell-button>
    <yo-button *ngIf="!hasBonReception(cell.row.data)"
      buttonClass="cta-inner-edit-or-watch"
      iconClass="fas fa-truck"
      size="small"
      (onClick)="openReassignDialog(cell.row.data)"
      tooltip="Réassigner la proposition sélectionnée">
    </yo-button>
  </div>
  <div *dxTemplate="let cell of 'templateUdp'">
    <td>
      <yo-site [siteId]="cell.row.data.site.id" [siteLibelleTooltip]="cell.row.data.site.libelle"
               [siteLibelle]="cell.row.data.uniteDeProductionLibelle"></yo-site>
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateDateCommande'">
    <td style="text-align: right;">
      {{ cell.row.data.dateCommande | date:'dd/MM/yyyy' | titlecase }}
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateDateLivraison'">
    <td style="text-align: right;">
      {{ cell.row.data.dateLivraisonAjustee | date:'dd/MM/yyyy' | titlecase }}
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateMontantHT'">
    <td style="text-align: right;">
      {{ cell.row.data.montantHT | currency:'EUR':'symbol':'1.4-4' }}
      <span *ngIf="isMinimumCommandInError(cell.row.data)">
            <i class="fas fa-cart-arrow-down danger-color space"
               title="Minimum de commande non atteint"></i>
      </span>
      <span *ngIf="isConditionneParInError(cell.row.data)">
            <i class="fas fa-box-open danger-color space"
               title="Conditionné par non respecté"></i>
      </span>
      <span *ngIf="isFraisPortApplyed(cell.row.data)">
            <i class="fas fa-truck danger-color space"
               title="Des frais de port sont appliqués"></i>
      </span>
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateRemarques'">
    <td style="text-align: left;"
    >
      <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(utils.stripeHtml(cell.row.data.commentaire))">
      </p>
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateLbde'">
    <td style="text-align: left;">
      <a title="Aller sur la liste de besoins"
         (click)="wkfSvc.goToListeBesoinsDetails(cell.row.data.workflowInstance)"><span
        class="cursor save-color">{{cell.row.data.listeBesoinLibelle}}</span></a>
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateBonCf'">
    <div>
      <span class="mg-r-5">{{cell.row.data.numeroBcf}}</span>
      <yo-email-histo-button
        [code]="cell.row.data.numeroBcf"
        [emailHisto]="cell.row.data.mailHisto"
        (onMailHistoRetrieve)="onEmailHistoRretreived($event)">
      </yo-email-histo-button>
    </div>
    <div>
      <yo-gef-audit-button
        [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditListBonCommande, cell.row.data.id)">
      </yo-gef-audit-button>
    </div>
  </div>
  <div *dxTemplate="let cell of 'templateBonReception'">
    <td style="text-align: left;">
      <div class="p-grid">
        <div class="p-col-fixed width-50">
          <yo-button tooltip="Créer un bon de réception"
                     *ngIf="isEditableBonReception(auth2Svc.isSiteLocal(cell.row.data.site.id), cell.row.data.bonReceptionList) && isAddButtonBonReceptionAvailable(cell.row.data)"
                     buttonClass="cta-inner-secondary"
                     iconClass="fas fa-plus"
                     (onClick)="createBonReception($event, cell.row.data)"></yo-button>
        </div>
        <div class="p-col">
          <div *ngFor="let bonReception of cell.row.data.bonReceptionList">
            <ng-container
              *ngTemplateOutlet="tplBonReception;context:{bonReception:bonReception}"></ng-container>
          </div>
        </div>
      </div>
    </td>
  </div>

  <dxo-sorting mode="single"></dxo-sorting>
  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} commande(s) à réceptionner">
  </dxo-pager>

</dx-data-grid>

<!--DIALOG MODIFIER UNE COMMANDE  À RÉCEPTIONNER-->
<yo-bc-edit-fournisseur [displayDialog]="displayEditDialog" (onSave)="onBonCommandSaved()"
                        (onClose)="displayEditDialog=$event" [bonCf]="bonCf" [lignesBonCf]="lignesBonCf"
                        [bonCfs]="commandesAReceptionner"></yo-bc-edit-fournisseur>

<!--DIALOG DE CREATION DE BON DE RECEPTION-->
<p-dialog
  [modal]="true"
  [dismissableMask]="false"

  [style]="{'width':'900px'}"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayCreateBonReception">

  <!--TITRE-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-plus"></i> Créer un bon de réception pour la
      commande {{selectedBonCf?.numeroBcf}}
    </div>
  </ng-template>

  <!--  CONTENT -->
  <div class="mg-t-10">

    <form [formGroup]="formBonReception" novalidate>
      <ng-container *ngFor="let field of fieldsBonReception">
        <yo-dynamic-form-field-bs [fields]="fieldsBonReception" [field]="field"
                                  [form]="formBonReception"></yo-dynamic-form-field-bs>
      </ng-container>
    </form>

  </div>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <yo-button iconClass="fas fa-plus" tooltip="Créer le bon de réception" class="mg-r-5"
                   (onClick)="initBonReception()"></yo-button>
        <yo-button iconClass="fas fa-times" (onClick)="displayCreateBonReception=false"
                   buttonClass="cta-delete"></yo-button>
      </div>
    </div>


  </ng-template>


</p-dialog>

<!--TEMPLATE COLONNE BON DE RECEPTION DANS GRILLE COMMANDES À RÉCEPTIONNER-->
<ng-template #tplBonReception let-bonReception="bonReception">

  <!--  <p-contextMenu [global]="true" [target]="divBonReception" [model]="items" ></p-contextMenu>-->
  <p-menu appendTo="body" #menuActions [model]="brlActions" [popup]="true"></p-menu>

  <div>

    <div (click)="chooseBrlAction(menuActions,$event,bonReception)" class="cursor">
      <span class="mg-r-5">
        <yo-statuts-reception [bonReception]="bonReception"></yo-statuts-reception>
      </span>
      <span class="mg-r-5">
        <label class="genlabel cursor">{{ bonReception?.numeroBonReception | uppercase }}</label>
      </span>
    </div>

    <yo-litige-warning class="mg-r-5" [bonReception]="bonReception"></yo-litige-warning>

    <yo-gef-audit-button
      [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditListBonReception, bonReception?.id)">
    </yo-gef-audit-button>

  </div>

</ng-template>

<!--TEMPLATE NUMERO BON COMMANDE-->
<ng-template #tplNumeroBcf let-bonCf="bonCf">

  <span class="mg-r-5 ">{{bonCf.numeroBcf}}</span>
  <span class="mg-r-5" *ngIf="bonCf.mailHisto">

        <!--statut du bon de réception-->
    <label

      [title]="mailHistoSvc.getLabelStatut(bonCf.mailHisto.statut)"
      class="badge mg-r-5 cursor"
      [class.badge-warning]="bonCf.mailHisto.statut === BONCF_MAIL_STATUT.EN_COURS_ENVOI"
      [class.badge-primary]="bonCf.mailHisto.statut === BONCF_MAIL_STATUT.ENVOYE"
      [class.badge-success]="bonCf.mailHisto.statut === BONCF_MAIL_STATUT.LU"
      [class.badge-danger]="bonCf.mailHisto.statut === BONCF_MAIL_STATUT.EN_ERREUR"
      (click)="openHistoriqueMails(bonCf)">
       <span class="fa-layers fa-fw">
    <i class="fas fa-envelope mg-r-5"></i>
    <span class="fa-layers-counter">{{mailHistoSvc.getShortLabel(bonCf.mailHisto.statut)}}</span>
  </span>
    </label>

  </span>
</ng-template>

<yo-dialog-article-reception-grid (onClose)="displayDialogArticlesReception=$event"
                                  [displayEdit]=true
                                  (onSave)="updateCommandesFournisseurs($event)"
                                  [displayDialog]="displayDialogArticlesReception">
</yo-dialog-article-reception-grid>

<yo-merge-boncf
  #mergeComponent
  [displayDialog]="displayMergeDialog"
  [selectedBonCfsToMerge]="selectedBonCfsToMerge"
  [uniteDeProduction]="selectedUniteDeProductionToMerge"
  (onSave)="mergeBonsCf($event)"
  (onClose)="onCloseMerge($event)"></yo-merge-boncf>

<yo-reassignBcFournisseurDialog></yo-reassignBcFournisseurDialog>

<dx-popup
  [showTitle]="true"
  title="Éléments sans correspondance "
  [visible]="displayNoCorrespondancePopup"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeNoCorrespondancePopup(false)"
>
  <label>Les éléments non présents dans cette liste ont bien été réassignés.</label>
  <dx-data-grid
    [dataSource]="noCorrespondanceList"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
  >
    <dxi-column dataField="referenceArticle" caption="Réf. article" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxi-column dataField="description" caption="Description" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
  <div class="d-flex mg-t-10 justify-content-end">
    <yo-button
      class="mg-l-5 cta-edit-or-watch"
      label="Ouvrir le nouveau bon de commande"
      (onClick)="closeNoCorrespondancePopup(true)"
      iconClass="fas fa-external-link">
    </yo-button>
  </div>
</dx-popup>
